var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "详情",
        visible: _vm.visible,
        width: "920px",
        "append-to-body": "",
        "custom-class": "pre-card-detail-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "detail-content",
        },
        [
          _c("section", { staticClass: "detail-section" }, [
            _c("h3", { staticClass: "section-title" }, [_vm._v("基础信息")]),
            _vm._v(" "),
            _c("div", { staticClass: "info-grid" }, [
              _c("div", { staticClass: "info-column" }, [
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("制卡批次号："),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.detailData.batchNo || "--"))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("卡面名称："),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.detailData.cardFaceName || "--")),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("剩余可用数量："),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.getAvailableCount(_vm.detailData))),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("创建人："),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.detailData.creator || "--"))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "info-label" }, [_vm._v("备注：")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.detailData.remark || "--"))]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-column" }, [
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "info-label" }, [_vm._v("状态：")]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      class: [
                        "status-text",
                        _vm.getStatusClass(_vm.detailData.status),
                      ],
                    },
                    [_vm._v(_vm._s(_vm.getStatusText(_vm.detailData.status)))]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("生成数量："),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.detailData.totalCount || 0))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("创建时间："),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.detailData.createTime || "--")),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("可用小程序："),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.getProgramNames(_vm.detailData))),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "detail-section card-section" }, [
            _c("h3", { staticClass: "section-title" }, [_vm._v("卡信息")]),
            _vm._v(" "),
            _c("div", { staticClass: "info-row" }, [
              _c("span", { staticClass: "info-label" }, [
                _vm._v("卡号ID范围："),
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.detailData.cardNoRange || "--"))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-row range-row" }, [
              _c("span", { staticClass: "info-label" }, [
                _vm._v("剩余可分配卡号段："),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "range-text" }, [
                _vm._v(_vm._s(_vm.detailData.remainingCardNoRange || "--")),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "detail-section log-section" },
            [
              _c("h3", { staticClass: "section-title" }, [
                _vm._v("已分配日志："),
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticClass: "log-table",
                  attrs: { data: _vm.assignLogs, size: "mini", border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "卡号段",
                      align: "center",
                      "min-width": "110",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.getCardNoRangeList(
                              scope.row.cardNoRange || scope.row.card_no_range
                            ).length
                              ? _c(
                                  "div",
                                  { staticClass: "card-range-list" },
                                  _vm._l(
                                    _vm.getCardNoRangeList(
                                      scope.row.cardNoRange ||
                                        scope.row.card_no_range
                                    ),
                                    function (range, index) {
                                      return _c(
                                        "div",
                                        {
                                          key:
                                            scope.$index +
                                            "-" +
                                            index +
                                            "-" +
                                            range,
                                          staticClass: "card-range-line",
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(range) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _c("span", [_vm._v("--")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "customerOrderId",
                      label: "客户订单ID",
                      align: "center",
                      width: "90",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "quantity",
                      label: "数量",
                      align: "center",
                      width: "90",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "状态", align: "center", width: "110" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                class: [
                                  "log-status",
                                  _vm.getLogStatusClass(scope.row.status),
                                ],
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.getLogStatusText(scope.row.status))
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "福卡名",
                      align: "center",
                      "min-width": "110",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(_vm.getLogCardName(scope.row))),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "发放小程序",
                      align: "center",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(_vm.getLogProgramName(scope.row))),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "assignTime",
                      label: "分配时间",
                      align: "center",
                      "min-width": "150",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", align: "center", width: "90" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return scope.row.status == 0 &&
                              scope.row.assignStatus == 0
                              ? [
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "has-permi",
                                          rawName: "v-has-permi",
                                          value: [
                                            "admin:order:customer:pre:resetData",
                                          ],
                                          expression:
                                            "['admin:order:customer:pre:resetData']",
                                        },
                                      ],
                                      attrs: {
                                        type: "text",
                                        size: "mini",
                                        loading: _vm.resetLoading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleResetLog(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              重置数据\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              : undefined
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "detail-section log-section" },
            [
              _c("h3", { staticClass: "section-title" }, [
                _vm._v("重置日志："),
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticClass: "log-table",
                  attrs: { data: _vm.resetLogs, size: "mini", border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "卡号段",
                      align: "center",
                      "min-width": "110",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.getCardNoRangeList(
                              scope.row.cardNoRange || scope.row.card_no_range
                            ).length
                              ? _c(
                                  "div",
                                  { staticClass: "card-range-list" },
                                  _vm._l(
                                    _vm.getCardNoRangeList(
                                      scope.row.cardNoRange ||
                                        scope.row.card_no_range
                                    ),
                                    function (range, index) {
                                      return _c(
                                        "div",
                                        {
                                          key:
                                            scope.$index +
                                            "-" +
                                            index +
                                            "-" +
                                            range,
                                          staticClass: "card-range-line",
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(range) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _c("span", [_vm._v("--")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "customerOrderId",
                      label: "客户订单ID",
                      align: "center",
                      width: "90",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "quantity",
                      label: "数量",
                      align: "center",
                      width: "90",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "状态", align: "center", width: "110" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              { staticClass: "log-status log-status-danger" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.getResetLogStatusText(scope.row.status)
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "福卡名",
                      align: "center",
                      "min-width": "110",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(_vm.getLogCardName(scope.row))),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "发放小程序",
                      align: "center",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(_vm.getLogProgramName(scope.row))),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "assignTime",
                      label: "分配时间",
                      align: "center",
                      "min-width": "150",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "resetUserName",
                      label: "重置人",
                      align: "center",
                      width: "90",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "resetTime",
                      label: "重置时间",
                      align: "center",
                      "min-width": "150",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }